import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';
import { replaceInvalidIriChars } from 'src/utils/removeInvalidIriChars';

const getDefaultProjectDataPrefix = (project: Pick<Project, 'name'>) =>
  `urn:${replaceInvalidIriChars(project.name)}:`;

/**
 * Migration to reset `dataNamespace` to the default value based on project name.
 * This ensures all projects use a consistent namespace format and prevents
 * the namespace from changing when projects are renamed or duplicated.
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v50 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v50Projects(prevState.projects);
  }

  return nextState;
};

const v50Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    projectsById[projectId] = {
      ...project,
      dataNamespace:
        project.dataNamespace || getDefaultProjectDataPrefix(project),
    };
  });

  return { ...prevProjectsState, projectsById };
};
